import _styled from "@emotion/styled/base";
import React, { useContext } from 'react';
import Loader from 'react-loader-spinner';
import { ThemeContext } from '@emotion/react';
import 'react-loader-spinner/dist/loader/css/react-spinner-loader.css';
import { jsx as ___EmotionJSX } from "@emotion/react";
const Spinner = _ref => {
  let {
    size,
    color
  } = _ref;
  const {
    brand_color
  } = useContext(ThemeContext);
  return ___EmotionJSX(Loader, {
    type: "Oval",
    color: color ? color : brand_color,
    width: size,
    height: size
  });
};
Spinner.defaultProps = {
  size: 80
};
export const SpinnerContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e7zgspb0"
} : {
  target: "e7zgspb0",
  label: "SpinnerContainer"
})("display:flex;justify-content:center;align-items:center;height:", props => props.height, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9hcHAvbm9kZV9tb2R1bGVzL0BpbnRlcm5lc3Mvd2ViLWNvcmUvc3JjL2NvbXBvbmVudHMvbW9kdWxlcy9TcGlubmVyL1NwaW5uZXIuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBc0IwQyIsImZpbGUiOiIvYXBwL25vZGVfbW9kdWxlcy9AaW50ZXJuZXNzL3dlYi1jb3JlL3NyYy9jb21wb25lbnRzL21vZHVsZXMvU3Bpbm5lci9TcGlubmVyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IHVzZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzICAgICAgICAgICAgIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IExvYWRlciAgICAgICAgICAgICAgICBmcm9tICdyZWFjdC1sb2FkZXItc3Bpbm5lcic7XG5pbXBvcnQgc3R5bGVkICAgICAgICAgICAgICAgIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBUaGVtZUNvbnRleHQgfSAgICAgIGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuaW1wb3J0ICdyZWFjdC1sb2FkZXItc3Bpbm5lci9kaXN0L2xvYWRlci9jc3MvcmVhY3Qtc3Bpbm5lci1sb2FkZXIuY3NzJztcblxuY29uc3QgU3Bpbm5lciA9ICh7IHNpemUsIGNvbG9yIH0pID0+IHtcbiAgY29uc3QgeyBicmFuZF9jb2xvciB9ID0gdXNlQ29udGV4dChUaGVtZUNvbnRleHQpO1xuICByZXR1cm4gPExvYWRlciB0eXBlPVwiT3ZhbFwiIGNvbG9yPXtjb2xvciA/IGNvbG9yIDogYnJhbmRfY29sb3J9IHdpZHRoPXtzaXplfSBoZWlnaHQ9e3NpemV9Lz5cbn07XG5cblNwaW5uZXIucHJvcFR5cGVzID0ge1xuICBzaXplOiBQcm9wVHlwZXMubnVtYmVyLFxuICBjb2xvcjogUHJvcFR5cGVzLnN0cmluZyxcbn07XG5cblNwaW5uZXIuZGVmYXVsdFByb3BzID0ge1xuICBzaXplOiA4MCxcbn07XG5cbmV4cG9ydCBjb25zdCBTcGlubmVyQ29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgZGlzcGxheTogZmxleDtcbiAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGhlaWdodDogJHtwcm9wcyA9PiBwcm9wcy5oZWlnaHR9O1xuYDtcblxuZXhwb3J0IGRlZmF1bHQgU3Bpbm5lcjtcbiJdfQ== */"));
export default Spinner;